import { whenConsented } from "../helper/whenConsented";
import { isDefined } from "../../ceres/helper/utils";
import { getCookie, setCookie } from "./cookieHelper";

export function abTestCookieCheck(response, store) {
	if (isDefined(response.data.wk) && isDefined(App.Eros)) {
		App.Eros.wk = response.data.wk;

		whenConsented(
			(App.Eros.BackendConfig.abTest.enableFrontendAssignment ? "" : "tracking.googleanalytics"),
			() => {
				const curCookie = getCookie("wk");
				const hasExpId = typeof App.Eros.Config.google.experimentID === "string" && App.Eros.Config.google.experimentID.length > 0;
				const expectedValue = (hasExpId ? (App.Eros.Config.google.experimentID + "." + response.data.wk) : response.data.wk);

				if (curCookie !== expectedValue) {
					setTimeout(() => {
						setCookie("wk", expectedValue, 100);
						store.dispatch("AbtestModule/checkCookie");
					}, 200);
				}
			},
			() => {}
		);
	}
}
